module.exports = __webpack_public_path__ + "components/flag/static/square/tr-ff52ca4c793b84073990ad503616bf3a.svg";